import { render, staticRenderFns } from "./camera-field.vue?vue&type=template&id=395d3f0e&scoped=true"
import script from "./camera-field.vue?vue&type=script&lang=js"
export * from "./camera-field.vue?vue&type=script&lang=js"
import style0 from "./camera-field.vue?vue&type=style&index=0&id=395d3f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395d3f0e",
  null
  
)

export default component.exports